/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React from 'react';
import ReactDOM from 'react-dom';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import App from './App';
import Context from './context/Contex';
import ContextDownload from './context/ContextDownload';
import ContextReports from './context/ContextReports';
import './assets/scss/lucia-kit-css.scss';
// import './assets/css/lucia-kit-css.css'

ReactDOM.render(
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <ContextDownload.Provider>
      <ContextReports.Provider>
        <Context.Provider>
          <App />
        </Context.Provider>
      </ContextReports.Provider>
    </ContextDownload.Provider>
  </MuiPickersUtilsProvider>,
  document.getElementById('app'),
);
